import { utils } from "../../core/helpers/utils";
import { middlewareService } from "../../shared/service";

export const onboardingService = {
  addPan,
  setCanDetails,
  getRequiredDocsList,
  uploadDocs,
  uploadKycDetails,
  getOtp,
  storeData,
  getUserDocState,
  getOnboardingUserDocState,
};

function addPan(dob, pan, fullname, nickname, checkExisting, forBse) {
  const payload = {
    pan: pan,
    dob: dob,
    checkExisting: checkExisting,
    isAjax: true,
    Platform: "web",
    source: "iosApp",
  };

  if (fullname) {
    payload["fullname"] = fullname;
    payload["nickname"] = nickname;
  }

  if (forBse) {
    payload["forBse"] = true;
  }

  const requestOptions = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "use-pkey": false
    },
  };

  return fetch(
    process.env.REACT_APP_API_URL +
      "/app/v1/customerDashboard/profile/applyNewCan1",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return utils.parsePayload(result);
    });
}

function setCanDetails(payload) {
  payload.isAjax = true;
  payload.formType = "formCPD";

  const requestOptions = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "use-pkey": false
    },
  };

  return fetch(process.env.REACT_APP_API_URL + "/users/profile", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return utils.parsePayload(result);
    });
}

function getRequiredDocsList(pan, forBse) {
  const payload = {
    pan: pan,
    isAjax: true,
    source: "iosApp",
    Platform: "web",
  };

  if (forBse) {
    payload["forBse"] = true;
  }

  const requestOptions = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "use-pkey": false
    },
  };

  return fetch(
    process.env.REACT_APP_API_URL +
      "/app/v1/customerDashboard/profile/getDocsRequired",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return utils.parsePayload(result);
    });
}

function uploadDocs(docType, email, pan, doc, fileName) {
  const formData = new FormData();
  fileName
    ? formData.append("useruploadcandocs", doc, fileName)
    : formData.append("useruploadcandocs", doc);
  formData.append("name", docType);

  const requestOptions = {
    method: "POST",
    headers: {
      "use-pkey": false
    },
    credentials: "include",
    body: formData,
  };

  //document.type
  return fetch(
    process.env.REACT_APP_API_URL +
      "/users/uploadDocs?email=" +
      email +
      "&pan=" +
      pan +
      "&type=" +
      docType,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return utils.parsePayload(result);
    });
}

function uploadKycDetails(payload) {
  payload["isAjax"] = true;
  payload["Platform"] = "web";
  payload["source"] = "iosApp";

  const requestOptions = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      "use-pkey": false
    },
  };

  return fetch(
    process.env.REACT_APP_API_URL +
      "/app/v1/customerDashboard/profile/applyNewCan2",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return utils.parsePayload(result);
    });
}

function getOtp(payload) {
  return middlewareService.postApiData("/otp/v2/sendOtp", payload);
}

function storeData(payload) {
  return middlewareService.postApiData("/kyc/v2/storeData", payload);
}

function getUserDocState(payload) {
  return middlewareService.postApiData("/users/userDocStats", payload);
}

function getOnboardingUserDocState(payload) {
  return middlewareService.postApiData("/users/getUserDocsWithPan",
    utils.getPKey() ? { payload: utils.encryptedPayload(payload) } : payload);
}
